import { Inject, Injectable } from '@angular/core';
import { CommonService } from '../../common/services/common.service';
import { environment } from '../../../../environments/environment';
import { constant } from '../../common/constant/constants';
import { HttpProvider } from '../../common/http/http-provider.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { LoginUser } from '../../common/model/loginuser.model';

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  constructor(private router: Router, public http: HttpProvider, private commonService: CommonService) {
  }

  public loginUser(returnUrl: string, user?: LoginUser, showMessage: boolean = true) {
    this.http.post<LoginUser>("UserDetails", user).subscribe({
      next: (data: LoginUser) => {
        debugger;
        let user = new LoginUser;
        user.Token = data.Token;
        if (showMessage)
          this.commonService.successMessage(this.commonService.translate.instant("Login.AlertLoginSuccess"));
        this.commonService.saveLocalStorageData('Token', data.Token, constant.localStorageType.localStorage);
        this.commonService.setcurrentUser(data);
        this.commonService.router.navigate([returnUrl || '/']);
      },
      error: () => {
        if (returnUrl)
          this.router.navigate(['/login'], { queryParams: { returnUrl: returnUrl } })
        else
          this.router.navigate(['/login']);
      }
    })
  }

  public goToSSO(returnUrl: string = undefined) {
    let navigateUrl = (returnUrl ? `${environment.apiUrl}Login?returnUrl=${returnUrl}` : `${environment.apiUrl}Login`);
    window.location.href = navigateUrl;
    // window.location.href = "/project";
  }

  logoutUser(navigateToLogin: boolean = true) {
    this.processAfterLogout(navigateToLogin);
  }

  private processAfterLogout(navigateToLogin: boolean = true) {
    localStorage.removeItem('User');
    this.commonService.clearLocalStorageData();
    this.commonService.setcurrentUser(new LoginUser());

    if (navigateToLogin && window.location.pathname != '/login') {
      setTimeout(() => { this.commonService.HideShowLoader(false) }, 10);
      this.commonService.router.navigateByUrl('/login');
    }
  }

}
